import { objectToLine } from "../../util/convert";
import send from "../../util/request";

export const sendMessageApi = (data = {}) => {
	return send({ url: '/ipp/message/send', method: 'POST', data: objectToLine(data) });
};

//物流追踪
export function purchaseGoodsLogistics(params) {
	return send({ url: '/ipp/order-purchase/logistics', params });
}


export const planOrderCreate = (data = {}) => {
	return send({ url: '/ipp/plan-order/create', method: 'POST', data });
};

export const planOrderAgainOrder = (data = {}) => {
	return send({ url: '/ipp/plan-order/again-order', method: 'POST', data });
};

export const planOrderCancel = (data = {}) => {
	return send({ url: '/ipp/plan-order/cancel', method: 'POST', data });
};


export const planOrderReceive = (data = {}) => {
	return send({ url: '/ipp/plan-order/receive', method: 'POST', data });
};
